<template>
<div class="chapter">
<div class="inner_page">
<h1 class="fm-title1" id="fm-1"><a id="page_ix"><span class="smallcaps">ABBREVIATIONS USED IN FOOTNOTES</span></a></h1><a id="page_ix">
<table>
<tbody><tr>
<td class="abb1"><p class="abbre"><span class="abb"><em>Bib</em></span></p></td>
<td class="abb2"><p class="abbre1"><em>Biblica</em></p></td>
</tr>
<tr>
<td class="abb1"><p class="abbre"><span class="abb"><em>BKW</em></span></p></td>
<td class="abb2"><p class="abbre1"><em>Bible Key Words from Gerhard Kittel’s Theologisches Wörterbuch zum Neuen Testament</em> (J. R. Coates, <em>et al.</em>, eds.). New York: Harper &amp; Row, 1951–1960. 3 vols.</p></td>
</tr>
<tr>
<td class="abb1"><p class="abbre"><span class="abb"><em>CBQ</em></span></p></td>
<td class="abb2"><p class="abbre1"><em>Catholic Biblical Quarterly</em></p></td>
</tr>
<tr>
<td class="abb1"><p class="abbre"><span class="abb"><em>EQ</em></span></p></td>
<td class="abb2"><p class="abbre1"><em>Evangelical Quarterly</em></p></td>
</tr>
<tr>
<td class="abb1"><p class="abbre"><span class="abb"><em>Eschatologie</em></span></p></td>
<td class="abb2"><p class="abbre1">H. D. Wendland, <em>Die Eschatologie des Reiches Gottes bei Jesus</em>. Gütersloh: Bertelsmann, 1931.</p></td>
</tr>
<tr>
<td class="abb1"><p class="abbre"><span class="abb"><em>ET</em></span></p></td>
<td class="abb2"><p class="abbre1"><em>Expository Times</em></p></td>
</tr>
<tr>
<td class="abb1"><p class="abbre"><span class="abb"><em>HDB</em></span></p></td>
<td class="abb2"><p class="abbre1"><em>A Dictionary of the Bible</em> (James Hastings, ed.). New York: Scribners, 1908. 5 vols.</p></td>
</tr>
<tr>
<td class="abb1"><p class="abbre"><span class="abb"><em>HTR</em></span></p></td>
<td class="abb2"><p class="abbre1"><em>Harvard Theological Review</em></p></td>
</tr>
<tr>
<td class="abb1"><p class="abbre"><span class="abb"><em>IB</em></span></p></td>
<td class="abb2"><p class="abbre1"><em>The Interpreter’s Bible</em> (George Arthur Buttrick, <em>et al.</em>, eds.). Nashville: Abingdon Press, 1952–57. 12 vols.</p></td>
</tr>
<tr>
<td class="abb1"><p class="abbre"><span class="abb"><em>IDB</em></span></p></td>
<td class="abb2"><p class="abbre1"><em>The Interpreter’s Dictionary of the Bible</em> (George Arthur Buttrick, <em>et al.</em>, eds.). Nashville: Abingdon, 1962. 4 vols.</p></td>
</tr>
<tr>
<td class="abb1"><p class="abbre"><span class="abb"><em>Int</em></span></p></td>
<td class="abb2"><p class="abbre1"><em>Interpretation</em></p></td>
</tr>
<tr>
<td class="abb1"><p class="abbre"><span class="abb"><em>ISBE</em></span></p></td>
<td class="abb2"><p class="abbre1"><em>The International Standard Bible Encyclopaedia</em> (James Orr, <em>et al.</em>, eds.). Chicago: Howard-Severance, 1930. 5 vols.</p></td>
</tr>
<tr>
<td class="abb1"><p class="abbre"><span class="abb"><em>JBL</em></span></p></td>
<td class="abb2"><p class="abbre1"><em>Journal of Biblical Literature</em></p></td>
</tr>
<tr>
<td class="abb1"><p class="abbre"><span class="abb"><em>JBR</em></span></p></td>
<td class="abb2"><p class="abbre1"><em>Journal of Bible and Religion</em></p></td>
</tr>
<tr>
<td class="abb1"><p class="abbre"><span class="abb"><em>Judaism</em></span></p></td>
<td class="abb2"><p class="abbre1">George Foot Moore, <em>Judaism in the First Centuries of the Christian Era</em>. Cambridge: Harvard University, 1927. 3 vols.</p></td>
</tr>
<tr>
<td class="abb1"><p class="abbre"><span class="abb"><em>JR</em></span></p></td>
<td class="abb2"><p class="abbre1"><em>Journal of Religion</em></p></td>
</tr>
<tr>
<td class="abb1"><p class="abbre"><span class="abb"><em>Kommentar</em></span></p></td>
<td class="abb2"><p class="abbre1">Herman L. Strack and Paul Billerbeck, <em>Kommentar zum Neuen Testament aus Talmud und Midrasch</em>. München: Beck, 1922–28. 5 vols.</p></td>
</tr>
<tr>
<td class="abb1"><p class="abbre"><span class="abb"><em>Mission</em></span></p></td>
<td class="abb2"><p class="abbre1"><a id="page_x">Reginald H. Fuller, <em>The Mission and Achievement of Jesus</em>. (<em>Studies in Biblical Theology</em>, XII.) Naperville: Allenson, 1954.</a></p></td>
</tr>
<tr>
<td class="abb1"><p class="abbre"><span class="abb"><em>NTS</em></span></p></td>
<td class="abb2"><p class="abbre1"><em>New Testament Studies</em></p></td>
</tr>
<tr>
<td class="abb1"><p class="abbre"><span class="abb"><em>RGG</em></span></p></td>
<td class="abb2"><p class="abbre1"><em>Die Religion in Geschichte und Gegenwart</em> (Kurt Galling, ed.; 3rd ed.). Tübingen: Mohr, 1957–61. 5 vols.</p></td>
</tr>
<tr>
<td class="abb1"><p class="abbre"><span class="abb"><em>SJTh</em></span></p></td>
<td class="abb2"><p class="abbre1"><em>Scottish Journal of Theology</em></p></td>
</tr>
<tr>
<td class="abb1"><p class="abbre"><span class="abb"><em>StTh</em></span></p></td>
<td class="abb2"><p class="abbre1"><em>Studia Theologica</em></p></td>
</tr>
<tr>
<td class="abb1"><p class="abbre"><span class="abb"><em>ThTo</em></span></p></td>
<td class="abb2"><p class="abbre1"><em>Theology Today</em></p></td>
</tr>
<tr>
<td class="abb1"><p class="abbre"><span class="abb"><em>TLZ</em></span></p></td>
<td class="abb2"><p class="abbre1"><em>Theologische Literaturzeitung</em></p></td>
</tr>
<tr>
<td class="abb1"><p class="abbre"><span class="abb"><em>TWBB</em></span></p></td>
<td class="abb2"><p class="abbre1"><em>A Theological Word Book of the Bible</em> (Alan Richardson, ed.). London: S.C.M.; 1950. New York: Macmillan, 1962.</p></td>
</tr>
<tr>
<td class="abb1"><p class="abbre"><span class="abb"><em>TZ</em></span></p></td>
<td class="abb2"><p class="abbre1"><em>Theologische Zeitschrift</em></p></td>
</tr>
<tr>
<td class="abb1"><p class="abbre"><span class="abb"><em>TWNT</em></span></p></td>
<td class="abb2"><p class="abbre1"><em>Theologisches Wörterbuch zum Neuen Testament</em> (Gerhard Kittel, <em>et al.</em>, eds.). Stuttgart: Kohlhammer, 1933–1964. 6 vols. to date.</p></td>
</tr>
<tr>
<td class="abb1"><p class="abbre"><span class="abb"><em>ZNTW</em></span></p></td>
<td class="abb2"><p class="abbre1"><em>Zeitschrift für die neutestamentliche Wissenschaft</em></p></td>
</tr>
<tr>
<td class="abb1"><p class="abbre"><span class="abb"><em>ZSysTh</em></span></p></td>
<td class="abb2"><p class="abbre1"><em>Zeitschrift für systematische Theologie</em></p></td>
</tr>
<tr>
<td class="abb1"><p class="abbre"><span class="abb"><em>ZTK</em></span></p></td>
<td class="abb2"><p class="abbre1"><em>Zeitschrift für Theologie und Kirche</em></p></td>
</tr>
</tbody></table>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 006_Abbreviations.vue?499e407f